// Central theme tokens and responsive helpers

export const theme = {
  colors: {
    background: '#0b0b0b',
    backgroundAlt: '#131313',
    textPrimary: 'rgba(255,255,255,0.92)',
    textSecondary: 'rgba(255,255,255,0.7)',
    borderSoft: 'rgba(255,255,255,0.12)',
    borderStrong: 'rgba(255,255,255,0.24)',
    glass: 'rgba(255,255,255,0.06)',
    // Brand accents (purple palette)
    brandPrimary: '#A259FF',
    brandAccent: '#E0BBFF',
    brandText: '#EBDEFF',
    brandBgStart: '#000000',
    brandBgEnd: '#291B32'
  },
  spacing: (n) => n * 4,
  radii: {
    sm: 8,
    md: 12,
    lg: 20,
    pill: 999
  },
  shadows: {
    soft: { color: 'rgba(0,0,0,0.25)', offset: { width: 0, height: 4 }, opacity: 1, radius: 4 },
  },
  breakpoints: {
    xs: 0,
    sm: 480,
    md: 768,
    lg: 1024,
    xl: 1440,
  },
  // Fixed header dimensions
  header: {
    navbarHeight: 56, // Base navbar height
    tickerHeight: 40, // Game ticker height
    // Total header height based on whether ticker is visible
    totalHeight: (tickerVisible = false) => tickerVisible ? 56 + 40 : 56,
    // Spacing to add below header for page content
    contentOffset: (w, tickerVisible = false) => {
      const baseOffset = tickerVisible ? 56 + 40 : 56;
      // Add responsive padding
      const padding = w >= 1024 ? 24 : w >= 768 ? 20 : 16;
      return baseOffset + padding;
    }
  },
  layout: {
    contentMaxWidth: (w) => (w >= 1920 ? 1400 : w >= 1440 ? 1280 : w >= 1024 ? 1080 : w >= 768 ? 920 : w >= 480 ? 720 : 540),
    pagePaddingX: (w) => (w >= 1440 ? 64 : w >= 1024 ? 56 : w >= 768 ? 48 : w >= 480 ? 28 : 16),
    pagePaddingY: (w) => (w >= 1440 ? 48 : w >= 1024 ? 40 : w >= 768 ? 32 : 24),
    mainVerticalPad: (w) => (w >= 1024 ? 96 : w >= 768 ? 72 : 48),
    searchHeight: (w) => (w >= 1024 ? 72 : w >= 768 ? 64 : 56),
    buttonPadY: (w) => (w >= 1024 ? 18 : w >= 768 ? 16 : 14),
    buttonPadX: (w) => (w >= 1024 ? 36 : w >= 768 ? 30 : 24),
    titleBase: (w) => (w >= 1440 ? 112 : w >= 1024 ? 100 : w >= 768 ? 72 : w >= 480 ? 48 : 34),
  }
};

export function useBreakpoint() {
  const getW = () => {
    try {
      if (typeof window !== 'undefined' && window.innerWidth) return window.innerWidth;
    } catch {}
    try {
      const { width } = require('react-native').Dimensions.get('window');
      return width;
    } catch {
      return 1024;
    }
  };

  const w = getW();
  const key = w >= theme.breakpoints.xl ? 'xl' : w >= theme.breakpoints.lg ? 'lg' : w >= theme.breakpoints.md ? 'md' : w >= theme.breakpoints.sm ? 'sm' : 'xs';
  return { width: w, key, isXs: key === 'xs', isSm: key === 'sm', isMd: key === 'md', isLg: key === 'lg', isXl: key === 'xl' };
}


